export enum GlTaxCodeLocationEnum {
  INLAND = 'INLAND',
  EU = 'EU',
  NON_EU = 'NON_EU',
}
